import { Country } from './types'

export const getCountryStatus = (
  countries: Country[],
  selectedCountryName: string | undefined
) => {
  const selectedCountry = countries.find(
    country => country.country === selectedCountryName
  )
  return selectedCountry?.allowed
}
